import { Author } from "../../manifest/models/author.models";
import { PostData } from "../../posts/post.models";
import { CyclingBank } from "../../utils/collections/cycling_bank";
import { getUsernameFor } from "../../utils/username";

export class AuthorGenerator extends CyclingBank<Author> {
  addPostAuthors(posts: PostData[]): PostData[] {
    if (posts.length > this.bank.length) {
      console.debug(
        "length check failed for author generator on main post data",
      );
      console.debug(
        `${posts.length} authors needed but author bank only has ${this.bank.length}`,
      );
    }
    return posts.map((post) => {
      try {
        const author = this.getNextObject();

        return {
          ...post,
          author: getUsernameFor(author),
          avatar: author.avatar.filename,
        };
      } catch (error) {
        console.debug("FATAL: Author bank exhausted generating post data");
        console.debug(
          `needed ${posts.length} posts but author bank only has ${this.bank.length}`,
        );
        throw error;
      }
    });
  }
}
